<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="tableWrap"
      rowKey="activityCode"
      :columns="columns"
      :queryParams="queryParams"
      :searchOptions="searchOptions"
      :request-promise="loadList"
      :show-reset-button="true"
    >
      <a-button slot="operation" type="primary" icon="plus" @click="onAddEvent">新建</a-button>

      <template v-slot:statusText="{ record }">
        {{ record.statusStr || statusTextMap[record.status] }}
      </template>

      <template v-slot:action="{ record }">
        <a-space>
          <a
            v-if="getStatusActionText(record.status)"
            class="status-action"
            @click="onStatusAction(record)"
          >{{ getStatusActionText(record.status) }}</a>
          <a @click="onEditEvent(record)">编辑</a>
          <a @click="onCopyLink(record)">复制链接</a>
        </a-space>
      </template>
    </StandardSearchPageView>

    <activity-copy-link-modal
      :visible.sync="copyLinkVisible"
      :activity="copyLinkRecord"
    />
  </div>
</template>

<script>
import moment from 'moment'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import ActivityCopyLinkModal from './ActivityCopyLinkModal.vue'

export default {
  name: 'ActivityListTab',
  components: {
    StandardSearchPageView,
    ActivityCopyLinkModal
  },
  data() {
    return {
      copyLinkVisible: false,
      copyLinkRecord: null,
      statusTextMap: {
        0: '未开始',
        1: '进行中',
        2: '已结束',
        3: '提前结束'
      },
      queryParams: {
        activityTitle: '',
        status: undefined,
        beginDate: undefined,
        endDate: undefined
      },
      searchOptions: [
        {
          name: '活动标题',
          key: 'activityTitle',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '活动状态',
          key: 'status',
          type: 'select',
          placeholder: '请选择',
          selectOptions: [
            { label: '未开始', value: 0 },
            { label: '进行中', value: 1 },
            { label: '已结束', value: 2 },
            { label: '提前结束', value: 3 }
          ]
        },
        {
          name: '活动日期',
          key: 'beginDate,endDate', // rangePicker 必须是两个字段，用,连接
          type: 'rangePicker'
        }
      ],
      columns: [
        { title: '活动ID', dataIndex: 'activityCode', width: 180 },
        { title: '活动标题', dataIndex: 'activityTitle', width: 320 },
        {
          title: '活动起止日期',
          dataIndex: 'startTime',
          width: 280,
          customRender: (text, record) => `${this.formatDate(record.startTime)} 至 ${this.formatDate(record.endTime)}`
        },
        {
          title: '状态',
          dataIndex: 'statusStr',
          width: 110,
          scopedSlots: { customRender: 'statusText' }
        },
        { title: '更新时间', dataIndex: 'updateTime', width: 180 },
        {
          title: '操作',
          dataIndex: 'action',
          width: 260,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    formatDate(value) {
      const time = moment(value)
      return time.isValid() ? time.format('YYYY-MM-DD') : value
    },
    /**
     * POST /marketingActivity/page
     * 入参：activityTitle/beginDate/endDate 必填（可为空串），status 为 null 或 0-3
     * BaseService 已在 status == 1 时 resolve 内层 data（标准分页结构 totalCount/pageCount/data）
     */
    loadList(requestParams) {
      const { limitDto, activityTitle, status, beginDate, endDate } = requestParams
      return this.getHttpServices().getNewServeService().post('/marketingActivity/page', {
        activityTitle: activityTitle || '',
        beginDate: beginDate || '',
        endDate: endDate || '',
        status: status === undefined ? null : status,
        limitDto
      })
    },
    getStatusActionText(status) {
      const actionMap = {
        0: '提前开始',
        1: '提前结束',
        2: '重新激活',
        3: '重新激活'
      }
      return actionMap[status] || ''
    },
    /**
     * editStatus 入参 status：1提前开始 / 2提前结束 / 3重新激活
     * 与列表活动状态（0未开始 1进行中 2已结束 3提前结束）不同
     */
    getEditStatusValue(activityStatus) {
      const statusMap = {
        0: 1,
        1: 2,
        2: 3,
        3: 3
      }
      return statusMap[activityStatus]
    },
    onAddEvent() {
      this.$router.push({ name: 'ActivityBasicInfo' })
    },
    onStatusAction(record) {
      const actionText = this.getStatusActionText(record.status)
      const editStatus = this.getEditStatusValue(record.status)
      if (!record || !record.activityCode || !actionText || editStatus == null) return
      this.$confirm({
        title: `确定${actionText}「${record.activityTitle || record.activityCode}」吗？`,
        onOk: () => this.editActivityStatus(record, editStatus, `${actionText}成功`)
      })
    },
    editActivityStatus(record, status, successMsg) {
      return this.getHttpServices()
        .getNewServeService()
        .post('/marketingActivity/editStatus', {
          activityCode: record.activityCode,
          status
        })
        .then(() => {
          this.$message.success(successMsg)
          this.$refs.tableWrap.refresh(false)
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '操作失败，请重试')
        })
    },
    onEditEvent(record) {
      if (!record || !record.activityCode) {
        this.$message.error('缺少活动ID')
        return
      }
      this.$router.push({
        name: 'ActivityBasicInfo',
        query: { activityCode: record.activityCode }
      })
    },
    onCopyLink(record) {
      if (!record || !record.activityCode) {
        this.$message.error('缺少活动ID')
        return
      }
      this.copyLinkRecord = record
      this.copyLinkVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
.status-action {
  color: #fa8c16;
}
</style>
